export const SETREFUNDLIST = "SETREFUNDLIST";
export const SETREFUNDLISTINAPPROVAL = "SETREFUNDLISTINAPPROVAL";
export const SETREFUNDATTACHMENTS = "SETREFUNDATTACHMENTS";
export const SETREFUNDAPPROVALSTATUS = "SETREFUNDAPPROVALSTATUS";
export const SETREFUNDLISTHEADERFILTERDATA = "SETREFUNDLISTHEADERFILTERDATA";

